import { render } from "./GoogleIcon.vue?vue&type=template&id=4949d437"
import script from "./GoogleIcon.vue?vue&type=script&lang=js"
export * from "./GoogleIcon.vue?vue&type=script&lang=js"
script.render = render

export default script